<div class="direct-search-form-container">

    <div class="direct-search-form-container">
        <div class="direct-search-form">
    
            <div class="row">
                <div class="col-sm-8 col-text">
                    Compagnia assicurativa
                </div>
                <div class="col-sm-4 col-select">
                    <select aria-label="Compagnia assicurativa" class="form-select comparatoreMF-box-shadow" [(ngModel)]="selectedCompany">
                        @if (companies$ | async | obsWithLoading; as companies) {
                            @if (companies) {
                                <option [value]="null">--nessuno--</option>
                                @for (company of companies; track company.FidaCode) {
                                    <option [value]="company.FidaCode">{{company.Name}}</option>
                                }
                            }
                            @if (companies.isLoading) {
                                <option disabled>Caricamento...</option>
                            }
                        }
                    </select>
                </div>
            </div>
        
            <div class="row">
                <div class="col-sm-8 col-text">
                    Anno di scadenza del prodotto
                </div>
                <div class="col-sm-4 col-select">
                    <select aria-label="Anno di scadenza del prodotto" class="form-select comparatoreMF-box-shadow" [(ngModel)]="selectedExpYear">
                        <option [value]="null">Vita intera</option>
                        <option *ngFor="let y of getExpirationYears()" [value]="y">{{y}}</option>
                    </select>
                </div>
            </div>
        
            <div class="row">
                <div class="col-sm-8 col-text">
                    Ramo della polizza vita
                </div>
                <div class="col-sm-4 col-select">
                    <select aria-label="Ramo della polizza vita" class="form-select comparatoreMF-box-shadow" [(ngModel)]="selectedRamoVita">
                        @if (ramiVita$ | async | obsWithLoading; as ramiVita) {
                            @if (ramiVita) {
                                <option [value]="null">--nessuno--</option>
                                @for (rv of ramiVita; track rv.FidaCode) {
                                    <option [value]="rv.FidaCode">{{rv.Name}}</option>
                                }
                            }
                            @if (ramiVita.isLoading) {
                                <option disabled>Caricamento...</option>
                            }
                        }
                    </select>
                </div>
            </div>
        
            <div class="row">
                <div class="col-sm-8 col-text">
                    Rischiosità della gestione finanziaria<br />(come da Kid)
                </div>
                <div class="col-sm-4 col-select">
                    <select aria-label="Rischiosità della gestione finanziaria (come da Kid)" class="form-select comparatoreMF-box-shadow" [(ngModel)]="selectedRiskLevel">
                        @if (riskLevels$ | async | obsWithLoading; as riskLevels) {
                            @if (riskLevels) {
                                <option [value]="null">--nessuno--</option>
                                @for (rl of riskLevels; track rl.FidaCode) {
                                    <option [value]="rl.FidaCode">{{rl.Name}}</option>
                                }
                            }
                            @if (riskLevels.isLoading) {
                                <option disabled>Caricamento...</option>
                            }
                        }
                    </select>
                </div>
            </div>
        
            <div class="row">
                <div class="col-sm-8 col-text">
                    Nome del prodotto
                </div>
                <div class="col-sm-4 col-select">
                    <input aria-label="Nome del prodotto" type="text" class="form-control comparatoreMF-box-shadow" [(ngModel)]="nameTyped" />
                </div>
            </div>
    
            
            <div class="row">
                <div class="col-sm-8"></div>
                <div class="col-sm-4">
                    <div class="direct-search-btn-container">
                        <app-btn padding="8px" color="mf-primary" (click)="loadSearch()" [disabled]="isSearchBtnDisabled() || isLoadingProducts">
                            @if(!isLoadingProducts) {
                                <span class="search-btn-txt">Cerca</span>
                            }
                            @else {
                                <mat-spinner *ngIf="isLoadingProducts" diameter="18" style="margin:0 auto;"></mat-spinner>
                            }
                        </app-btn>
                    </div>
                </div>
            </div>
        
        </div>
    </div>

</div>